import { createFileRoute } from '@tanstack/react-router'
import { DraftSuratPanel } from '../../../../components/draft-surat/DraftSuratPanel'

export const Route = createFileRoute('/platform/desa/$desaId/draft-surat')({
  component: () => {
    const { desaId } = Route.useParams()
    return <DraftSuratPanel desaId={desaId} />
  },
})
